import { render, staticRenderFns } from "./ServiceCommentMediaItem.vue?vue&type=template&id=217bfc0d&scoped=true"
import script from "./ServiceCommentMediaItem.vue?vue&type=script&lang=ts"
export * from "./ServiceCommentMediaItem.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCommentMediaItem.vue?vue&type=style&index=0&id=217bfc0d&prod&scoped=true&lang=scss"
import style1 from "./ServiceCommentMediaItem.vue?vue&type=style&index=1&id=217bfc0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217bfc0d",
  null
  
)

export default component.exports